import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'mlp-ng-text-button-internal',
    templateUrl: './text-button-internal.component.html',
    styleUrls: ['./text-button-internal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TextButtonInternalSharedComponent implements AfterViewInit {
    @Input() attributes: {[s: string]: string};
    @Input() label: string;
    @Input() url: string;
    @Input() iconName: string;
    @Input() iconNameAfter: string;
    @Input() iconNameAfterSize: string;
    @Input() weight = 'normal';
    @Input() queryParamsHandling = 'preserve';

    @ViewChild('aTag') aTagElement: ElementRef<HTMLElement>;

    ngAfterViewInit(): void {
        if (this.attributes) {
            Object.keys(this.attributes).forEach(key => {
                this.aTagElement.nativeElement.setAttribute(key, this.attributes[key]);
            });
        }
    }
}
